import { VaultDepositorData } from 'src/hooks/query/vaults/types';
import { UiVaults } from 'src/constants/vaults';
import { getAuthorityVaultBalance } from 'src/utils/vault/math';
import useGetOraclePriceForMarket from 'src/hooks/useGetOraclePriceForMarket';
import { VaultTags } from 'src/components/Vaults/VaultTags';
import Link from 'src/components/primitives/Link/Link';
import { AccountListItem } from './AccountListItem';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import { useVaultStats } from 'src/hooks/query/vaults/derived/useVaultStats';

export const VaultItem = ({ vault }: { vault: VaultDepositorData }) => {
	const vaultPubkey = vault.vault.pubkey.toString();
	const { data: vaultStat } = useVaultStats(vaultPubkey);
	const getOraclePriceForMarket = useGetOraclePriceForMarket();
	const isMobile = useIsMobileScreenSize();
	const handleCloseDrawer = useDrawersStore((s) => s.handleCloseDrawer);

	const handleClick = () => {
		if (isMobile) {
			handleCloseDrawer('accounts');
		}
	};

	const uiVaultConfig = UiVaults.getVaultConfig(vaultPubkey);

	if (!vaultStat || !uiVaultConfig) return null;

	const balance = getAuthorityVaultBalance(
		[vault.vaultDepositor],
		{ ...vaultStat, uiVaultConfig },
		'quote',
		getOraclePriceForMarket
	);

	const nameArea = (
		<div className="flex flex-col gap-y-xs">
			<div className="typo-b3 text-text-default">{uiVaultConfig.name}</div>
			<VaultTags
				uiVaultConfig={uiVaultConfig}
				numOfVaultSnapshots={vaultStat.numOfVaultSnapshots}
			/>
		</div>
	);

	const infoArea = (
		<div className="typo-t4 text-text-default">${balance.toMillified()}</div>
	);

	return (
		<Link
			href={`/vaults/strategy-vaults/${vaultPubkey}`}
			className="w-full"
			rightIcon="none"
		>
			<AccountListItem
				nameArea={nameArea}
				infoArea={infoArea}
				onClick={handleClick}
			/>
		</Link>
	);
};
